import Link from 'next/link';
import { FC } from 'react';
import { IoClose, IoPersonOutline } from 'react-icons/io5';

import { ActionIcon, Button, ButtonProps, Indicator } from '@mantine/core';

import { AuthenticationHelpers } from 'helpers/AuthenticationHelpers';

import { ModalService } from 'services/ModalService';

export type LoginButtonProps = {
    label?: string;
    linkable?: boolean;
    iconOnMobile?: boolean;
} & ButtonProps;

export const LoginButton: FC<LoginButtonProps> = ({
    label = 'Sign In',
    linkable = false,
    iconOnMobile = true,
    ...rest
}) => {
    // There is already a login form on the homepage
    // Having a modal on top of that is not a pretty experience
    const force = window?.location.pathname === '/';
    const currentPath = window?.location.pathname;
    const redirectUrl = currentPath && currentPath !== '/' ? `?redirect=${currentPath}` : '';

    const props =
        linkable || force
            ? {
                  component: Link,
                  href: `${AuthenticationHelpers.urls.login()}${redirectUrl}`,
              }
            : {
                  onClick: () => ModalService.openLoginModal(),
              };

    return (
        <>
            {iconOnMobile && (
                <Indicator
                    position="bottom-end"
                    hiddenFrom="xl"
                    color="red"
                    size={16}
                    offset={8}
                    withBorder
                    label={<IoClose size={10} />}
                    styles={{ indicator: { padding: 0 } }}
                >
                    {/* @ts-ignore */}
                    <ActionIcon {...props} variant="subtle" radius={99} size="lg">
                        <IoPersonOutline size={20} />
                    </ActionIcon>
                </Indicator>
            )}

            {/* @ts-ignore */}
            <Button
                {...props}
                variant="subtle"
                leftSection={<IoPersonOutline />}
                visibleFrom={iconOnMobile ? 'xl' : undefined}
                {...rest}
            >
                {label}
            </Button>
        </>
    );
};
